import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgIf} from '@angular/common';
import {TextsComponent} from '../texts/texts.component';
import {Text} from '../../../model/text';
import {ThemeService} from '../../../services/theme.service';
import {FooterService} from '../../../services/footer-service';

@Component({
  selector: 'app-running-line',
  imports: [
    TextsComponent,
    NgIf
  ],
  templateUrl: './running-line.component.html',
  standalone: true,
  styleUrl: './running-line.component.scss'
})
export class RunningLineComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('marqueeContent') marqueeContent!: ElementRef<HTMLDivElement>;
  private animationFrameId: number | null = null;
  private startTime: number | null = null;
  private speed = 100;
  private position = 0;

  constructor(
    public themeService: ThemeService,
    public footerService: FooterService,
    private elementRef: ElementRef
  ) {}

  @Input() otherText: boolean = false;
  @Input() title: string[] = ['Израиль', 'Israel'];
  @Input() text: Text[] = [
    {text: ['Добро пожаловать в ', 'Welcome to '],},
    {text: this.title, fontFamily: 'pd', fontStyle: 'italic'},
  ];
  @Input() background: boolean = false;
  @Input() footer: boolean = false;

  isMobile: boolean = false;


  ngOnInit(): void {
    if (window.innerWidth < 571) {
      this.isMobile = true;
    }
  }

  ngAfterViewInit() {
    this.startAnimation();
  }

  ngOnDestroy() {
    this.stopAnimation();
  }

  startAnimation() {
    this.position = 0;
    this.startTime = null;
    const animate = (timestamp: number) => {
      if (!this.startTime) this.startTime = timestamp;
      const elapsed = (timestamp - this.startTime) / 1000; // в секундах
      this.position = -elapsed * this.speed;
      const contentWidth = this.marqueeContent.nativeElement.scrollWidth / 2; // делим на 2, так как контент дублируется
      if (Math.abs(this.position) >= contentWidth) {
        this.position = 0;
        this.startTime = timestamp;
      }
      this.marqueeContent.nativeElement.style.transform = `translateX(${this.position}px)`;
      this.animationFrameId = requestAnimationFrame(animate);
    };
    this.animationFrameId = requestAnimationFrame(animate);
  }

  stopAnimation() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  getBackground() {
    const color = this.footerService.getFooterColor();
    return color || 'rgba(57, 122, 158, 1)';
  }
}
